/// <reference types="@angular/localize" />

import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// Registra Swiper.js.
import {register} from 'swiper/element/bundle';
register();

import _refiner from 'refiner-js';
_refiner('setProject', '57a43300-4ddb-11f0-8df1-5d3844f31622');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

  